interface SEOWebPageProps {
  pageType: string;
  pageUrl: string;
  pageTitle: string;
  pageDescription: string;
  datePublished?: string;
  dateModified?: string;
  breadcrumbItems?: { label: string; href?: string }[];
}

export default function SEOJsonLd({
  pageType,
  pageUrl,
  pageTitle,
  pageDescription,
  datePublished,
  dateModified,
  breadcrumbItems,
}: SEOWebPageProps) {
  const fullUrl = `https://www.aiqingdao.com${pageUrl}`;

  const webpageJson = {
    '@context': 'https://schema.org',
    '@type': pageType,
    name: pageTitle,
    description: pageDescription,
    url: fullUrl,
    ...(datePublished && { datePublished }),
    ...(dateModified && { dateModified }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJson) }}
    />
  );
}

export function ArticleJsonLd({
  title,
  description,
  url,
  datePublished,
  dateModified,
  authorName,
}: {
  title: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified?: string;
  authorName?: string;
}) {
  const fullUrl = `https://www.aiqingdao.com${url}`;

  const articleJson = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    url: fullUrl,
    datePublished,
    ...(dateModified && { dateModified }),
    author: {
      '@type': 'Organization',
      name: authorName || '爱情岛论坛网址导航',
    },
    publisher: {
      '@type': 'Organization',
      name: '爱情岛论坛网址导航',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJson) }}
    />
  );
}

export function FAQPageJsonLd({
  faqs,
}: {
  faqs: { question: string; answer: string }[];
}) {
  const faqJson = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJson) }}
    />
  );
}